import React from 'react';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledSpinner = styled.svg`
  height: 50px;
  width: 50px;
  & .inside {
    fill: none;
    stroke-width: 4;
    stroke-linecap: round;
    animation: spinning 1.5s infinite linear;
  }
  @keyframes spinning {
    0% {
      stroke-dashoffset: 251;
      stroke-dasharray: 75 50;
    }
    50% {
      stroke-dasharray: 0 125;
    }
    100% {
      stroke-dashoffset: 0;
      stroke-dasharray: 75 50;
    }
  }
`;

const Loading = () => (
  <Container>
    <StyledSpinner viewBox="0 0 50 50">
      <circle className="inside" stroke={'#00e88f'} cx="25" cy="25" r="20" />
    </StyledSpinner>
  </Container>
);

export default Loading;
